export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Escreva um post...',
  blogsFeedSearchInputPlaceholder: 'Pesquisar',
  blogsFeedPostOwnerCurtainEditTitle: 'Editar postagem',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Excluir postagem',
  blogsFeedEditedPostSavedAlertText: 'Postagem salva!',
  blogsFeedEditedPostDeletedAlertText: 'Postagem excluída!',
  blogsFeedShareCurtainOptionTitle: 'Copiar link',
  blogsFeedPostLinkCopiedAlertText: 'Link copiado!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Copiar link',
  blogsFeedOthersPosLinkCopiedAlertText: 'Link copiado!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Denunciar conteúdo',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Excluir postagem',
  blogsFeedPostDeletePopupTitle: 'Excluir',
  blogsFeedPostDeletePopupText: 'Tem certeza de que deseja excluir esta postagem?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Cancelar',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Confirmar',
  blogsFeedPostDeeletedAlertText: 'Postagem excluída!',
  blogsPostDetailsHeaderTitle: 'Postagem',
  postFeedPostLikesText: 'Curtidas',
  postFeedPostCommentsText: 'Comentários',
  postFeedPostNoLikesText: 'Não há curtidas ainda',
  postFeedPostLeaveFirstLikeText: 'Você pode ser o primeiro a curtir',
  blogsFeedPostDetailsNoCommentsText: 'Ainda não há comentários',
  blogsFeedPostDetailsFirstCommentText: 'Você pode ser o primeiro a comentar',
  blogsFeedPostDetailsShareOptionTitle: 'Copiar link',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Link copiado!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copiar link',
  blogsFeedPostDetailsCopiedAlertText: 'Link copiado!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Denunciar conteúdo',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Denunciar',
  blogsPostDetailsReportedCurtainText: 'Conteúdo denunciado',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Editar comentário',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Excluir comentário',
  blogsPostDetailsEditedCommentSavedAlertText: 'Comentário salvo!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Excluir comentário',
  postDetailsOtherUsersCommentDeletadAlertText: 'Comentário excluído!',
  postDetailsDeleteCommentPopupTitle: 'Excluir',
  postDetailsDeleteCommentPopupText: 'Tem certeza de que deseja excluir este comentário?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  postDetailsCommDeletedAlertText: 'Comentário excluído!',
  postDetailsCommentUserCurtainOptionTitle: 'Denunciar comentário',
  blogsCreatePostCurtainTitle: 'Nova postagem',
  blogsCreatePostCurtainBodyPlaceholder: 'Digite seu texto aqui...',
  blogsCreatePostPublishButtonTitle: 'Publicar',
  blogsCreatePostUploadSlallerImageAlertText: 'Você pode fazer upload de no máximo {size} MB por vez',
  blogsPostSavedAlertText: 'Postagem salva!',
  blogsCreatePostAddLocationCurtainTitle: 'Localização',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Nome da localização',
  blogsCreatePostEditLocationCurtainText: 'Editar localização',
  blogsDeleteLocation: 'Excluir localização',
  blogsDiscardPostPopupTitle: 'Rascunho',
  blogsDiscardPostPopupText: 'Descartar este rascunho?',
  blogsDiscardPostPopupCancelButtonTitle: 'Cancelar',
  blogsDiscardPostPopupCofirmButtonTitle: 'Confirmar',
  blogsNewPostCreatePollTitle: 'Criar enquete',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Título',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Opção',
  blogsNewPostCreatePollAddButtonTitle: 'Adicionar opção',
  blogsNewPostCreatePollCreateButtonTitle: 'Criar',
  blogsCreatePostPollTitleBlankAlertText: 'O título não pode estar em branco!',
  blogsCreatePostPollOptionBlankAlertText: 'A opção não pode estar em branco!',
  blogsCreatePostPollLongTitleAlertText: 'O título deve conter no máximo {length} caracteres',
  blogsCreatePostPollLongOptionAlertText: 'A opção deve conter no máximo {length} caracteres',
  blogsCreatePostPollEditOptionTitle: 'Editar enquete',
  blogsCreatePostPollRemoveOptionTitle: 'Remover enquete',
  blogsPostPollInfoVotesText: 'votos',
  blogsPostPollInfoEditVoteText: 'Editar voto',
  blogsPostPollFinishPollText: 'Finalizar enquete',
  blogsPostPollFinishedPollText: 'Finalizado',
  blogsPostPollInProgresslText: 'Em andamento',
  blogsFinishPollCurtainTitle: 'Finalizar enquete',
  blogsFinishPollCurtainText: 'Os usuários não poderão mais votar após a finalização da enquete.',
  blogsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  blogsPollInfoPollVotesCurtainTitle: 'Votos da enquete',
  blogsEditPostCurtainTitle: 'Editar postagem',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Digite seu texto aqui...',
  blogsEditPostCurtainSaveButtonTitle: 'Salvar',
  blogsEditPostSavedAlertText: 'Postagem salva!',
  blogsError: 'Algo deu errado!',
  blogsAt: 'em',
  blogsSeeMore: 'Ver mais...',
  blogsMaxAttachments: 'Você excedeu o número máximo de anexos. O máximo é {length}',
  blogsReply: 'Responder',
  blogsAddCover: 'Adicionar imagem de capa'
}
